import { render, staticRenderFns } from "./OpenedUsers.vue?vue&type=template&id=d12fae1a&scoped=true&"
import script from "./OpenedUsers.vue?vue&type=script&lang=js&"
export * from "./OpenedUsers.vue?vue&type=script&lang=js&"
import style0 from "./OpenedUsers.vue?vue&type=style&index=0&id=d12fae1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12fae1a",
  null
  
)

export default component.exports